export abstract class PassFacetStrategyService {
  abstract haveFacetConditionsChildrenNames(filtersNames: string[]);
  abstract resetFacetConditionsChildrenNames();

  abstract register(any);

}
